import React, { useState } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import ViewHistoryWtItemReturn from '../../../components/Modal/ViewHistoryWtItemReturn';

import { formatCurrency, getAlert, parseCurrency, updateStatusByNo } from "../../../../utils/SamuiUtils";
import { formatThaiDateUi } from "../../../../utils/DateUtils";
import { manageWhItemData } from "../../../../utils/WarehouseUtils";

const Main = ({ name, dataMasterList, dataDetailList, dataMasterHistoryList, dataDetailHistoryList, onPageInsert, onPageUpdate }) => {

  // สำหรับข้อมูลรายการ
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [wtEmpName, setWtEmpName] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  // สำหรับข้อมูลประวัติการยืม
  const [filteredDetailHistoryList, setFilteredDetailHistoryList] = useState([]);
  const [whHistoryCustName, setWhHistoryCustName] = useState("");
  const [selectedHistoryRow, setSelectedHistoryRow] = useState(null);

  // เก็บข้อมูลที่เลือกรายละเอียดสินค้าที่จะคืน
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // เก็บตัวแปรสำหรับเปิด Modal ดูประวัติ
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const onRowSelected = async (fromData) => {
    setSelectedRow(fromData.WTDoc_Emp_Id);

    // พี่คินอยากให้กระพริบ เดี๋ยวไปร์ทจัดให้
    setFilteredDetailList([]);
    setWtEmpName("");

    setTimeout(() => {
      const filteredDetail = dataDetailList.filter(data => parseCurrency(data.WTDoc_Emp_Id) === fromData.WTDoc_Emp_Id);

      if (filteredDetail && filteredDetail.length > 0) {
        setFilteredDetailList(filteredDetail);
      } else {
        setFilteredDetailList([]);
      }

      setWtEmpName(fromData.WTDoc_Emp_Name);
    }, 50);
  };

  const onRowSelectHistory = async (fromHistoryData) => {
    setSelectedHistoryRow(fromHistoryData.WTDoc_Emp_Id);

    // พี่คินอยากให้กระพริบ เดี๋ยวไปร์ทจัดให้
    setFilteredDetailHistoryList([]);
    setWhHistoryCustName("");

    setTimeout(() => {
      const filteredHistoryDetail = dataDetailHistoryList
        .filter(
          data => parseCurrency(data.WTDoc_Emp_Id) === fromHistoryData.WTDoc_Emp_Id
        );

      if (filteredHistoryDetail && filteredHistoryDetail.length > 0) {
        setFilteredDetailHistoryList(filteredHistoryDetail);
      } else {
        setFilteredDetailHistoryList([]);
      }

      setWhHistoryCustName(fromHistoryData.WTDoc_Emp_Name);
    }, 50);
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState('');
  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      data.WTDoc_Emp_Code.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.WTDoc_Emp_Name.toLowerCase().includes(searchItemTerm.toLowerCase());

    return matchesItemSearchTerm;
  });

  const handleCheckboxChange = (itemSelected) => {
    const updatedSelectedItems = selectedItems.some(item => item.DT_Id === itemSelected.DT_Id)
      ? selectedItems.filter(item => item.DT_Id !== itemSelected.DT_Id)
      : [...selectedItems, itemSelected];
    setSelectedItems(updatedSelectedItems);
  };

  const handleConfirmReturn = async () => {
    if (selectedItems.length === 0) {
      getAlert("FAILED", "กรุณาเลือกรายการที่ต้องการคืน");
      return;
    }

    for (const selectedItem of selectedItems) {
      // คืนคลังสินค้า
      await manageWhItemData(
        selectedItem.Item_Id, // Item ไอดีของสิ่งนั้นๆ
        selectedItem.Item_Code, // Item โค้ดของสิ่งนั้นๆ
        selectedItem.Item_Name, // ชื่อ Item นั้นๆ
        selectedItem.F_WT_Id, // WarehouseID ของไอเทม
        "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
        parseCurrency(selectedItem.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
        selectedItem.WTDoc_Id, // ไอดีเอกสาร
        selectedItem.WTDoc_No, // เลขเอกสาร
        selectedItem.WTDoc_No, // เลขเอกสารอ้างอิง
        `คืนสินค้า` // หมายเหตุ
      );

      // อัพเดตสถานะเอกสาร
      await updateStatusByNo("WTDoc_D", "Item_Is_Return", parseCurrency(1), `WHERE DT_Id = ${selectedItem.DT_Id}`);
    }

    // กรองสินค้าที่คืนไปแล้วออกจาก filteredDetailList
    // dataDetailList.filter(
    //   (item) => !selectedItems.some((selected) => selected.WTDoc_Id === item.WTDoc_Id)
    // )

    // กลับโหมดเดิม
    setIsCheckboxEnabled(false);
    setSelectedItems([]);

    // await callInitialize();
    // await onRowSelected(formData);
    // getAlert("OK", `คืนสินค้าสําเร็จ`);
    window.location.reload();
  };

  return <>
    <Breadcrumbs page={name} items={[
      { name: 'ใบยืม-ใบเบิก', url: '/borrow-withdrawal' },
      { name: name, url: '/office-equip-form' },
    ]} />
    <div className="container-fluid card py-3">
      <div className="row mb-2 align-items-center">
        <div className="col-2">
          <button
            className="btn text-white mx-3"
            onClick={() => onPageInsert()}
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              whiteSpace: 'nowrap',
              padding: '10px',
              fontSize: '15px'
            }}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> {name}
          </button>
        </div>
        <div className="col-2">
          <div className="input-group">
            <span className="input-group-text">Search</span>
            <input
              type="text"
              className="form-control"
              value={searchItemTerm}
              onChange={(e) => setSearchItemTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6" />
        <div className="col-2 d-flex justify-content-end">
          <button
            className="btn d-flex align-items-center text-white me-2"
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              fontSize: '16px',
            }}
            onClick={() => setShowHistoryModal(true)}
          >
            <i className="fa fa-search me-2" aria-hidden="true"></i>
            ประวัติการเบิก
          </button>

          <ViewHistoryWtItemReturn
            showHistoryModal={showHistoryModal}
            setShowHistoryModal={setShowHistoryModal}
            dataMasterHistoryList={dataMasterHistoryList}
            filteredDetailHistoryList={filteredDetailHistoryList}
            selectedHistoryRow={selectedHistoryRow}
            whHistoryCustName={whHistoryCustName}
            formatThaiDateUi={formatThaiDateUi}
            formatCurrency={formatCurrency}
            onRowSelectHistory={onRowSelectHistory}
            onPageUpdate={onPageUpdate}
          />

        </div>
      </div>
      <hr />
      <div className="row ">
        <div className="col-4 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
          <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
            <table id="basic-datatables" className="table table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '10%' }}>ลำดับ</th>
                  <th className="text-center" style={{ width: '20%' }}>รหัสพนักงาน</th>
                  <th className="text-center" style={{ width: '70%' }}>ชื่อพนักงาน</th>
                </tr>
              </thead>
              <tbody>
                {filteredItemData.length > 0 ? (
                  filteredItemData.map((data, index) => (
                    <tr
                      key={data.WTDoc_Emp_Id || index + 1}
                      onClick={() => onRowSelected(data)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor:
                          selectedRow === data.WTDoc_Emp_Id
                            ? "rgb(105, 188, 216)"
                            : "transparent",
                        transition: "background-color 0.3s ease",
                      }}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{data.WTDoc_Emp_Code}</td>
                      <td className="text-left">{data.WTDoc_Emp_Name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-8 mb-3">
          <div className="justify-content-between align-items-center mb-3">
            <div className="row">
              <div className="col-6">
                <p className="card-title mb-0">
                  ชื่อพนักงาน: {wtEmpName}
                </p>
              </div>
              {(!isCheckboxEnabled && filteredDetailList.length > 0) &&
                <div className="col-6 d-flex justify-content-end">
                  <button
                    className="btn d-flex align-items-center text-white me-2"
                    style={{
                      backgroundColor: 'rgb(239, 108, 0)',
                      fontSize: '16px',
                    }}
                    onClick={() => setIsCheckboxEnabled(!isCheckboxEnabled)}
                  >
                    <i className="fa fa-edit me-2" aria-hidden="true"></i>
                    เลือกคืนสินค้า
                  </button>
                </div>
              }
            </div>
          </div>
          <div
            className="table-responsive"
            style={{
              maxHeight: '600px',
              overflowY: 'auto',
            }}
          >
            <table
              id="basic-datatables"
              className="table table-striped table-hover"
              style={{ minWidth: '100%' }}
            >
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '2%' }}>ลำดับ</th>
                  <th className="text-center" style={{ width: '2%' }}>
                    <input
                      type="checkbox"
                      disabled={!isCheckboxEnabled}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        const validItems = filteredDetailList.filter(item => item.WTDocStatus_Name !== 'ยกเลิก');
                        setSelectedItems(checked ? validItems : []);
                      }}
                      checked={
                        filteredDetailList.length > 0 &&
                        selectedItems.length === filteredDetailList.filter(item => item.WTDocStatus_Name !== 'ยกเลิก').length
                      }
                    />
                  </th>
                  <th className="text-center" style={{ width: '10%' }}>วันที่เอกสาร</th>
                  <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                  <th className="text-center" style={{ width: '10%' }}>สถานะ</th>
                  <th className="text-center" style={{ width: '15%' }}>รหัสสินค้า</th>
                  <th className="text-center" style={{ width: '54%' }}>ชื่อสินค้า</th>
                  <th className="text-center" style={{ width: '10%' }}>จำนวน</th>
                  <th className="text-center" style={{ width: '2%' }}>
                    <i className="fa fa-edit" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredDetailList.length > 0 ? (
                  filteredDetailList
                    .filter((item) => item.Item_Is_Return === 0)
                    .map((item, index) => (
                      <tr
                        key={item.DT_Id || index + 1}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: selectedItems.some(select => select.DT_Id === item.DT_Id) ? 'rgb(105, 188, 216)' : 'transparent',
                          transition: 'background-color 0.3s ease',
                        }}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            disabled={!isCheckboxEnabled || item.WTDocStatus_Name === 'ยกเลิก'}
                            checked={selectedItems.some(select => select.DT_Id === item.DT_Id)}
                            onChange={() => handleCheckboxChange(item)}
                            style={{ cursor: 'pointer' }}
                          />
                        </td>
                        <td className="text-center">{formatThaiDateUi(item.WTDoc_Date)}</td>
                        <td className="text-center">{item.WTDoc_No}</td>
                        <td className="text-center">
                          <button
                            className="btn"
                            style={{
                              backgroundColor: item.WTDocStatus_Colour,
                              color: 'white',
                              width: '100%'
                            }}
                          >
                            {item.WTDocStatus_Name}
                          </button>
                        </td>
                        <td className="text-center">{item.Item_Code}</td>
                        <td className="text-left">{item.Item_Name}</td>
                        <td className="text-center">{item.Item_Qty}</td>
                        <td className="text-center">
                          <button
                            hidden={item.WTDocStatus_Name === 'ยกเลิก'}
                            className="btn btn-sm"
                            onClick={() => onPageUpdate(item.WTDoc_No)}
                          >
                            <i className="fa fa-edit" />
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="14">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                {isCheckboxEnabled && (
                  <tr>
                    <td colSpan="9">
                      <div className="d-flex justify-content-left mt-3">
                        <button
                          className="btn btn-lg btn-success me-3"
                          onClick={() => setShowModal(true)}
                          disabled={selectedItems.length === 0}
                        >
                          ยืนยันการคืนสินค้า
                        </button>
                        <button
                          className="btn btn-lg btn-danger"
                          onClick={() => {
                            setIsCheckboxEnabled(false);
                            setSelectedItems([]);
                          }}
                        >
                          ยกเลิกการคืนสินค้า
                        </button>
                      </div>
                    </td>
                  </tr>
                )}

                {/* Modal */}
                <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                  <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title fw-bold">ยืนยันการคืนสินค้า</h5>
                        <button type="button" className="btn-close" onClick={() => setShowModal(false)} aria-label="Close"></button>
                      </div>
                      <div className="modal-body">
                        <p>คุณแน่ใจว่าต้องการดำเนินการยืนยันการคืนสินค้าหรือไม่?</p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-lg w-25 shadow text-white"
                          style={{ backgroundColor: '#EF6C00', fontSize: '16px' }}
                          onClick={() => handleConfirmReturn()}
                        >
                          ยืนยัน
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg w-25 shadow text-white"
                          style={{ backgroundColor: 'red', fontSize: '16px' }}
                          onClick={() => setShowModal(false)}
                        >
                          ยกเลิก
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>;
};

export default Main;